/**
 * Service pour les opérations Twitch CLI
 * @module admin/services/twitchCliService
 */

import { apiGet, apiPost } from '../../../utils/api';

/**
 * Récupère le statut du Twitch CLI
 * @returns {Promise<Object>} Statut du CLI (installed, version, error)
 * @throws {Error} Si la récupération échoue
 */
export const getCliStatus = async () => {
  return await apiGet('/admin/twitch-cli/status');
};

/**
 * Récupère la liste des événements disponibles
 * @returns {Promise<Object>} Liste des événements avec success et events
 * @throws {Error} Si la récupération échoue
 */
export const getAvailableEvents = async () => {
  return await apiGet('/admin/twitch-cli/events');
};

/**
 * Déclenche un événement EventSub via Twitch CLI
 * @param {string} eventType - Type d'événement à déclencher
 * @param {Object} options - Options de l'événement
 * @returns {Promise<Object>} Résultat du déclenchement (message, command, output, warnings)
 * @throws {Error} Si le déclenchement échoue
 */
export const triggerEvent = async (eventType, options) => {
  return await apiPost('/admin/twitch-cli/trigger', {
    eventType,
    options,
  });
};
